import { getCustomServiceCategories, WHEEL_ALIGNMENT } from "../../../../v1/actions/services"
import { getUpdatedCart } from "../../../../v1/helpers/orderHelpers"
import { ReactComponent as Bell } from "../../../../images/bell.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAdd } from "@fortawesome/pro-solid-svg-icons"
import { ReactComponent as DeleteIcon } from "../../../../images/delete_icon_vector_white_stroke.svg"
import { Button } from "semantic-ui-react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import React, { useEffect, useState } from "react"
import { updateCart } from "../../../../v1/actions/user"
import ShimmerSquare from "../../../../v1/components/ShimmerSquar"

const WheelAlignmentCard = ({
  cart,
  getCustomServiceCategories,
  updateCart,
  activeVehicle,
  onServiceAdded = (result) => {}
}) => {
  const hasWheelAlignment = cart.order_services.find(
    (service) => service?.reference_id === WHEEL_ALIGNMENT
  )
  const [wheelAlignmentService, setWheelAlignmentService] = useState(null)
  const [loading, setLoading] = useState(false)
  const [serviceLoading, setServiceLoading] = useState(false)
  useEffect(() => {
    fetchAvailableCategories()
  }, [])

  const fetchAvailableCategories = async () => {
    setServiceLoading(true)
    let categories = (await getCustomServiceCategories()) || null

    let categoryServices = categories?.flatMap((item) => [
      ...item.default,
      ...item.related_services
    ])

    const wheelAlignment = categoryServices.find(
      (service) => service.reference_id === WHEEL_ALIGNMENT
    )
    setWheelAlignmentService(wheelAlignment)
    setServiceLoading(false)
  }

  const toggleCart = () => {
    setLoading(true)
    const event = [
      {
        event: hasWheelAlignment ? "removed" : "added",
        service_definition_id: wheelAlignmentService.id
      }
    ]
    const onComplete = (result) => {
      setLoading(false)
      result && onServiceAdded(result)
    }
    updateCart(event, activeVehicle.id, null, true, {
      callback: onComplete,
      successCallback: onComplete
    })
  }

  if (serviceLoading) {
    return (
      <ShimmerSquare
        containerClass="h-[25px]"
        height={"476px"}
        className="w-2"
        style={{ margin: 0 }}
      />
    )
  }

  return (
    <div className="wheel-alignment-card">
      <div className="tip-section">
        <div className="tip-header">
          <Bell />
          <p>
            <b>Mechanic's Tip:</b> Alignment vs. Balancing
          </p>
        </div>
        <p className="tip-text">
          Your service includes Wheel Balancing, which prevents vibration. We suggest a Wheel
          Alignment to ensure your car drives straight and prevent uneven wear.
        </p>
      </div>

      <div className="price-section">
        <p className="service-name">Wheel Alignment</p>
        <div className="price-info">
          <p className="price">
            {hasWheelAlignment &&
            !isNaN(Number(hasWheelAlignment?.price_estimate?.shop_price_estimate))
              ? `$${Number(hasWheelAlignment?.price_estimate?.shop_price_estimate).toFixed(2)}`
              : `$${wheelAlignmentService?.price_range_from ?? "99.99"} - $${
                  wheelAlignmentService?.price_range_to ?? "120.80"
                }`}
          </p>
          <p className="partner">eBay-CarAdvise Partner Price</p>
        </div>
      </div>

      {hasWheelAlignment ? (
        <div
          className="cart-action"
          onClick={toggleCart}
          style={{ backgroundColor: "#3c3c3c", color: "white" }}
        >
          <DeleteIcon />
          <p>Remove</p>
        </div>
      ) : (
        <Button fluid onClick={toggleCart} className="primary-button" loading={loading}>
          <FontAwesomeIcon icon={faAdd} style={{ marginRight: "6px" }} />
          <b>Add</b>
        </Button>
      )}
    </div>
  )
}

function mapStateToProps(state, props) {
  const user = state.user || {}
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }

  return {
    cart,
    activeVehicle
  }
}

export default withRouter(
  connect(mapStateToProps, { getCustomServiceCategories, updateCart })(WheelAlignmentCard)
)
